// import toast from "react-hot-toast";

// const isAppleDevice = () => {
//   return /Mac|iPhone|iPad|iPod/.test(navigator.platform);
// };

// const isSafariBrowser = () => {
//   return (
//     /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
//     typeof window !== "undefined"
//   );
// };
// const isRestrictedAppleDownload = () => {
//   return isAppleDevice() && isSafariBrowser();
// };

// export const handleDownload = async (url: string, filename: string) => {
//   const toastId = toast.loading("Preparing your download...");
//   try {
//     const response = await fetch(url);
//     const blob = await response.blob();

//     if (isRestrictedAppleDownload()) {
//       // iOS doesn't support forced blob download well
//       const newTab = window.open(url, "_blank");
//       if (!newTab) {
//         throw new Error("Popup blocked. Please allow popups for this site.");
//       }
//       toast.dismiss(toastId);
//       toast.success("Opened in new tab for download");
//       return;
//     }

//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     toast.dismiss(toastId);
//     toast.success("Download started!");
//   } catch (error: any) {
//     toast.dismiss(toastId);
//     const errorMessage = error?.message || "Unknown error";
//     toast.error(`Failed to download the file: ${errorMessage}`);
//     console.error("Error downloading the file:", error);
//   }
// };
export function handleDownload(url: string, name?: string) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer"; // for security
  document.body.appendChild(a);
  a.click();
  a.remove();
}
